import React, { useState, useEffect } from "react";
import Header from "../../components/header/index.js";
import LeftMenu from "../../components/left-menu/index.js";
import { useSelector } from 'react-redux';
import {useNavigate} from "react-router-dom";
import Grid from '@mui/material/Grid';
import {readEmpty} from "../SalesMeeting/apiEmpty.js";
import "./style.css";
import { DatePicker } from '@mui/x-date-pickers';
import { Select, MenuItem } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import axios from "axios";
import Button from '@mui/material/Button';
import { Typography, Dialog, LinearProgress, DialogContent, Box, Card } from "@mui/material";
import TextField from '@mui/material/TextField';
import Autocomplete from "@mui/material/Autocomplete";
import CheckIcon from "@mui/icons-material/Check";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {Switch} from "@mui/material";

export default function LegalProcess() {
    const [selectedPerson, setSelectedPerson] = useState('Adnan');
    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [data, setData] = useState([]);
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB').format(date); // Format date as DD/MM/YYYY
      };
    const fetchData = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/kontrakexpiringreview`, {
            params: {
                startDate: selectedStartDate.toISOString(),
                endDate: selectedEndDate.toISOString()
            }
        })
            .then(response => {
                console.log(response.data)
                setData(response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    };

    useEffect(() => {
        fetchData();
    }, [selectedPerson, selectedStartDate, selectedEndDate]);

    const handlePersonChange = (event) => {
        setSelectedPerson(event.target.value);
      };

    const handleDateChangeStart = (newDate) => {
        setSelectedStartDate(newDate);
    };
    const handleDateChangeEnd = (newDate) => {
        setSelectedEndDate(newDate);
    };

    const checkStatus = (aa) => {
        if (aa?.statusExtend === "Yes") {
          return "Sudah Extent";
        } else if (aa?.TanggalBerakhir && new Date(aa.TanggalBerakhir) < new Date()) {
          return "Expired belum Perpanjang";
        } else if (!aa?.salesperson || !["Felly", "Adnan", "Dinda"].includes(aa.salesperson)) {
          return "Tidak ada Sales yang Handle";
        } else if (aa?.nextextendReminder === "Drop") {
          return `Drop by ${aa.salesperson}`;
        } else if (aa?.nextextendReminder) {
          return `${aa.salesperson} request Remind ${formatDate(aa.nextextendReminder)}`;
        }else if (aa?.nowRemind === "Yes"){
            return `Tunggu ${aa.salesperson} FU`
        }
        return  'error';
      };
    
    return (
        <Grid container>   
            <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                <LeftMenu/>
            </Grid>
            <Grid xl={11.5} lg={11.3} md={10.4} sm={8.8} sx={{py:10, px:10}}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container>
                    <Grid xs={3}>
                        <DatePicker
                            label="Start Date"
                            value={selectedStartDate}
                            onChange={handleDateChangeStart}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={1} container alignItems="center" justifyContent="center">
                    to
                </Grid>
                    <Grid xs={3}>
                        <DatePicker
                            label="End Date"
                            value={selectedEndDate}
                            onChange={handleDateChangeEnd}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </Grid>
                </Grid>
                </LocalizationProvider>
                <Grid container sx={{py:2}}>
                    <Grid xs={3} sx={{px:1}}>
                    <Card sx={{p:2}}>
                        <Typography sx={{ color: 'text.secondary' }}><b>Expiring Kontrak</b></Typography>
                        <Typography sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}>{data.kontrakExpiring}</Typography>
                        {/* <Typography sx={{
                            color: 'success.dark',
                            display: 'inline',
                            fontWeight: 'bold',
                            mx: 0.5,
                            fontSize: 14,
                        }}> +18.77%</Typography> */}
                        {/* <Typography sx={{ color: 'text.secondary', display: 'inline', fontSize: 14 }}>
                        vs. periode sebelumnya
                        </Typography> */}
                    </Card>
                    </Grid>
                    <Grid xs={3} sx={{px:1}}>
                    <Card sx={{p:2}}>
                        <Typography sx={{ color: 'text.secondary' }}><b>Kontrak Dropped</b></Typography>
                        <Typography sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}>{data.kontrakDropped}</Typography>
                        <Typography sx={{
                            color: 'error.dark',
                            display: 'inline',
                            fontWeight: 'bold',
                            mx: 0.5,
                            fontSize: 14,
                        }}> {data.kontrakUnknown}</Typography>
                        <Typography sx={{ color: 'text.secondary', display: 'inline', fontSize: 14 }}>
                        tidak memiliki status
                        </Typography>
                    </Card>
                    </Grid>
                    <Grid xs={3} sx={{px:1}}>
                    <Card sx={{p:2}}>
                        <Typography sx={{ color: 'text.secondary' }}><b>Kontrak Extend</b></Typography>
                        <Typography sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}>{data.kontrakExtend}</Typography>
                        {/* <Typography sx={{
                            color: 'success.dark',
                            display: 'inline',
                            fontWeight: 'bold',
                            mx: 0.5,
                            fontSize: 14,
                        }}> +18.77%</Typography> */}
                        {/* <Typography sx={{ color: 'text.secondary', display: 'inline', fontSize: 14 }}>
                        vs. periode sebelumnya
                        </Typography> */}
                    </Card>
                    </Grid>
                    
                </Grid>

                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ maxHeight: 300, minHeight: 300 }} className="min-h-screen h-screen overflow-scroll">
                            <Table stickyHeader aria-label="sticky table" className="fixed-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tanggal Expired</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Nama PT</TableCell>
                                        <TableCell>Kode Kontrak</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                    data && data.kontraklistexpiring && data.kontraklistexpiring.length > 0 ? (
                                        data.kontraklistexpiring.map((item) => (
                                        <TableRow> {/* Assuming each item has a unique 'id' property */}
                                            <TableCell>{formatDate(item?.TanggalBerakhir)}</TableCell>
                                            <TableCell>{checkStatus(item)}</TableCell>
                                            <TableCell>{item?.CompanyName || 'n/a'}</TableCell>
                                            <TableCell>{item?.kontrakAmount || 'n/a'}</TableCell>
                                        </TableRow>
                                        ))
                                    ) : null
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
            </Grid>
        </Grid>
    );
}
